export default {
  app: {
    loading: 'Loading...',
    somethingWentWrong: 'Something went wrong',
    pageNotFound: 'Page not found',
    signInFailed: 'Sign-in failed',
    close: 'Close',
  },
  welcome: {
    logoAlt: 'Weekly Squads',
    tagline:
      'A daily pack opening game where you build your squad for the upcoming weekend matches',
    cta: 'Log in or sign up',
  },
  nav: {
    locked: 'Locked',
  },
  lobby: {
    prize: 'Prize:',
    monthlyPrize: 'Monthly prize:',
    totals: {
      tackles: 'Tackles',
      intercepts: 'Intercepts',
      shots: 'Shots',
      goals: 'Goals',
      pts: 'Pts',
    },
    stats: 'T {{tackles}} • I {{interceptions}} • S {{shots}} • G {{goals}}',
    expiresIn: 'Expires in {{time}}',
    revealIn: 'Reveal in {{time}}',
    drawing: 'Drawing your squad…',
    enterError: 'Could not draw your squad. Close and reopen to try again.',
    opensIn: '{{round}} opens {{time}} from now.',
    openError: 'Could not open this pack. Close and try again.',
    lockError: 'Could not lock in that player. Please try again.',
    squadDetails: 'Squad details',
    homeFixture: 'vs {{club}} {{time}}',
    awayFixture: '@{{club}} {{time}}',
  },
  card: {
    expired: 'Expired',
    expiredOn: 'Expired {{date}}',
    pickYourPlayer: 'Pick your player',
    choosePlayer: 'Choose Player',
    revealPlayer: 'Reveal Player',
  },
  position: {
    Attacker: 'Striker',
    Midfielder: 'Midfielder',
    Defender: 'Defender',
    Goalkeeper: 'Goalkeeper',
  },
  reveal: {
    title: 'Today’s Reveal',
    lockedTitle: 'Player Locked In',
    swipeSub: 'Swipe to view players. Tap to select.',
    selectedSub: 'Player selected. Lock in to confirm.',
    lockedSub: 'Added to your Weekly Squad.',
    showPlayer: 'Show player {{n}}',
    lockIn: 'Lock in Player',
    viewSquad: 'View Weekly Squad',
    tapHint: 'Tap 1 player to select',
  },
  sheet: {
    leaderboard: 'Leaderboard',
    weekly: 'Weekly',
    monthly: 'Monthly',
    rank: 'Rank',
    user: 'User',
    shots: 'Shots',
    goals: 'Goals',
    pts: 'Pts',
    you: 'You',
    empty: 'No entries yet — the leaderboard fills as squads are drawn.',
  },
  info: {
    howToPlay: 'How to play',
    title: 'How to Play',
    rules: [
      'Open a free player pack each day, Monday to Friday, to build your squad for the weekend’s matches.',
      'Each pack unlocks at its scheduled reveal time — miss the window and the slot expires.',
      'Your revealed players earn points from real match events: {{goal}} for a goal, {{shot}} for a shot on target, {{tackle}} for a tackle and {{interception}} for an interception.',
      'Gold cards are rarer — keep an eye out for the gold treatment.',
      'Climb the leaderboard — each round, prizes go to a range of finishing positions.',
    ],
    logOut: 'Log out',
    account: 'Account',
    officialRules: 'Official rules',
    language: 'Language',
  },
  countdown: {
    day_one: '{{count}} Day',
    day_other: '{{count}} Days',
  },
  prize: {
    ordinal_one: '{{count}}st',
    ordinal_two: '{{count}}nd',
    ordinal_few: '{{count}}rd',
    ordinal_other: '{{count}}th',
    range: '{{from}} to {{to}}',
  },
};
